var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork2Icon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.96 36H37.24C38.8821 36.0225 40.4664 35.3942 41.6469 34.2524C42.8273 33.1106 43.5079 31.548 43.54 29.906V22.506",
    stroke: "#070811",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88006 10.788L27.7761 17.01C29.2567 17.4963 30.5503 18.4296 31.4786 19.6814C32.407 20.9331 32.9246 22.4419 32.9601 24V42.02C33.0224 42.6836 32.9222 43.3525 32.6681 43.9687C32.414 44.5849 32.0136 45.1299 31.5016 45.5567C30.9896 45.9834 30.3813 46.279 29.7294 46.418C29.0775 46.5569 28.4016 46.5349 27.7601 46.354L9.66206 41.434C8.17955 40.9727 6.87968 40.0569 5.94646 38.816C5.01323 37.5752 4.49393 36.0723 4.46206 34.52V14.624C4.42974 13.1719 4.9727 11.7659 5.9726 10.7125C6.97249 9.65898 8.34826 9.04345 9.80006 9H28.5401",
    stroke: "#070811",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.96 36C25.6168 36 26.96 34.6569 26.96 33C26.96 31.3431 25.6168 30 23.96 30C22.3031 30 20.96 31.3431 20.96 33C20.96 34.6569 22.3031 36 23.96 36Z",
    stroke: "#070811",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.54 15V3H39.04C39.8357 3 40.5987 3.31607 41.1614 3.87868C41.724 4.44129 42.04 5.20435 42.04 6C42.04 6.79565 41.724 7.55871 41.1614 8.12132C40.5987 8.68393 39.8357 9 39.04 9C39.8357 9 40.5987 9.31607 41.1614 9.87868C41.724 10.4413 42.04 11.2044 42.04 12C42.04 12.7956 41.724 13.5587 41.1614 14.1213C40.5987 14.6839 39.8357 15 39.04 15H34.54Z",
    stroke: "#070811",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.54 9H39.04",
    stroke: "#070811",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.54 3V1.5",
    stroke: "#070811",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.54 15V16.5",
    stroke: "#070811",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork2Icon3);
export default __webpack_public_path__ + "static/media/work2-icon3.fc425d46e2ad47dc4492f7b9e9ddbbad.svg";
export { ForwardRef as ReactComponent };